(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-future-home-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector("[data-ap-fhp]");
    if (!root) return;
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var previewPath = "/pages/ap-homepage-concept-2026-07-private";

    function suppressPreviewPopups() {
      if (window.location.pathname !== previewPath) return;
      document.documentElement.classList.add("ap-fhp-preview-page");

      var selector = [
        "[class*='klaviyo' i]",
        "[id*='klaviyo' i]",
        "iframe[src*='klaviyo' i]",
        "[class*='privy' i]",
        "[id*='privy' i]",
        "iframe[src*='privy' i]",
        "[class*='wisepops' i]",
        "[id*='wisepops' i]",
        "iframe[src*='wisepops' i]"
      ].join(",");

      document.querySelectorAll(selector).forEach(function (item) {
        item.setAttribute("data-ap-preview-suppressed", "true");
        item.style.setProperty("display", "none", "important");
      });

      document.querySelectorAll("body > div, body > section, body > iframe").forEach(function (item) {
        var text = (item.innerText || "").replace(/\s+/g, " ").trim();
        var styles = window.getComputedStyle(item);
        var rect = item.getBoundingClientRect();
        var isOverlay = styles.position === "fixed" || styles.position === "sticky";
        var looksLikeEmailOffer = /unlock|claim|15% off|your order|email address/i.test(text);
        if (isOverlay && looksLikeEmailOffer && rect.width > 120 && rect.height > 80) {
          item.setAttribute("data-ap-preview-suppressed", "true");
          item.style.setProperty("display", "none", "important");
        }
      });
    }

    suppressPreviewPopups();
    if (window.location.pathname === previewPath && "MutationObserver" in window) {
      var popupObserver = new MutationObserver(suppressPreviewPopups);
      popupObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { popupObserver.disconnect(); }, 12000);
    }

    function scrollRail(track, direction) {
      if (!track) return;
      var amount = Math.max(track.clientWidth * 0.86, 280);
      track.scrollBy({ left: amount * direction, behavior: reduceMotion ? "auto" : "smooth" });
    }

    root.querySelectorAll("[data-ap-rail]").forEach(function (rail) {
      var track = rail.querySelector("[data-ap-rail-track]");
      var prev = rail.querySelector("[data-ap-rail-prev]");
      var next = rail.querySelector("[data-ap-rail-next]");
      if (prev) prev.addEventListener("click", function () { scrollRail(track, -1); });
      if (next) next.addEventListener("click", function () { scrollRail(track, 1); });

      if (!reduceMotion && rail.getAttribute("data-ap-autoplay") === "true" && track) {
        window.setInterval(function () {
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
          track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + track.clientWidth, behavior: "smooth" });
        }, 6500);
      }
    });

    var productTrack = root.querySelector("[data-ap-diffuser-track]");
    var productPrev = root.querySelector("[data-ap-diffuser-prev]");
    var productNext = root.querySelector("[data-ap-diffuser-next]");
    if (productPrev) productPrev.addEventListener("click", function () { scrollRail(productTrack, -1); });
    if (productNext) productNext.addEventListener("click", function () { scrollRail(productTrack, 1); });

    if ("IntersectionObserver" in window && !reduceMotion) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });
      root.querySelectorAll(".ap-fhp-reveal").forEach(function (item) { observer.observe(item); });
    } else {
      root.querySelectorAll(".ap-fhp-reveal").forEach(function (item) { item.classList.add("is-visible"); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-homepage-rebuild-v2"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots=document.querySelectorAll('[data-goal]');
    if(!roots.length) return;
    roots.forEach(function(root){
      if(root.getAttribute('data-goal-bound')==='true') return;
      root.setAttribute('data-goal-bound','true');
      var tabs=[].slice.call(root.querySelectorAll('[data-goal-tab]'));
      var panels=[].slice.call(root.querySelectorAll('[data-goal-panel]'));
      var groups=[].slice.call(root.querySelectorAll('[data-goal-drawers]'));
      var label=root.querySelector('[data-drawers-label]');
      var labels={waterless:'Top sellers · Waterless',humidifying:'Top sellers · Humidifying',sand:'Top sellers · Sand candle',incense:'Top sellers · Incense'};
      var rails=[].slice.call(root.querySelectorAll('[data-rail]'));
      function updNav(rail){
        var wrap=rail.closest('.drawer__rail'); if(!wrap) return;
        var prev=wrap.querySelector('.drawer__nav--prev'), next=wrap.querySelector('.drawer__nav--next');
        var max=rail.scrollWidth-rail.clientWidth-16;
        if(prev) prev.disabled=rail.scrollLeft<=16;
        if(next) next.disabled=(rail.scrollLeft>=max)||(max<=16);
      }
      function updAllNav(){ rails.forEach(updNav); }
      rails.forEach(function(r){ r.addEventListener('scroll',function(){updNav(r);}); });
      function activate(goal){
        tabs.forEach(function(t){t.setAttribute('aria-selected', t.getAttribute('data-goal-tab')===goal ? 'true':'false');});
        panels.forEach(function(p){
          var on=p.getAttribute('data-goal-panel')===goal;
          p.classList.toggle('is-active',on);p.classList.remove('is-enter');
          if(on){window.requestAnimationFrame(function(){p.classList.add('is-enter');});}
        });
        groups.forEach(function(g){g.hidden=g.getAttribute('data-goal-drawers')!==goal;});
        if(label&&labels[goal]) label.textContent=labels[goal];
        window.setTimeout(updAllNav,60);
      }
      function doScroll(){var pw=root.querySelector('.goal__panelwrap'); if(pw) pw.scrollIntoView({behavior:'smooth',block:'nearest'});}
      function pick(goal){
        var first=!root.classList.contains('is-open');
        var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        var inner=root.querySelector('.goal__inner');
        if(first&&inner&&!reduce){
          var h0=inner.offsetHeight;               // collapsed height
          root.classList.add('is-open');
          activate(goal);
          var h1=inner.offsetHeight;               // expanded height
          inner.style.overflow='hidden';
          inner.style.height=h0+'px';
          void inner.offsetHeight;                 // commit start height
          inner.style.transition='height .6s cubic-bezier(.32,.72,0,1)';
          inner.style.height=h1+'px';              // grow into expanded size
          var finished=false;
          var done=function(e){
            if(finished)return; if(e&&e.propertyName&&e.propertyName!=='height')return;
            finished=true;
            inner.style.transition='';inner.style.height='';inner.style.overflow='';
            inner.removeEventListener('transitionend',done);
            doScroll();
          };
          inner.addEventListener('transitionend',done);
          window.setTimeout(done,850);
        } else {
          root.classList.add('is-open');
          activate(goal);
          if(first) window.setTimeout(doScroll,120);
        }
      }
      tabs.forEach(function(t){t.addEventListener('click',function(){pick(t.getAttribute('data-goal-tab'));});});
      root.addEventListener('click',function(e){
        var nav=e.target.closest('.drawer__nav');
        if(nav){var rl=nav.closest('.drawer__rail').querySelector('[data-rail]'); if(rl){rl.scrollBy({left:(nav.classList.contains('drawer__nav--next')?1:-1)*Math.round(rl.clientWidth*0.85),behavior:'smooth'});} return;}
        var steer=e.target.closest('[data-goto]');
        if(steer){e.preventDefault();pick(steer.getAttribute('data-goto'));root.querySelector('.goal__selector').scrollIntoView({behavior:'smooth',block:'start'});return;}
      });
      root.addEventListener('submit',function(event){
        var form=event.target.closest('[data-ap-setup-form]'); if(!form||!window.fetch) return;
        event.preventDefault();
        var button=form.querySelector('[data-ap-setup-atc]');
        if(button){button.disabled=true;button.classList.add('is-loading');}
        fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
          .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
          .then(function(){
            if(button){button.classList.remove('is-loading');button.classList.add('is-added');}
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('ap:cart:add'));
            window.setTimeout(function(){if(!button)return;button.disabled=false;button.classList.remove('is-added');},1600);
          }).catch(function(){if(button){button.classList.remove('is-loading');}form.submit();});
      });
      activate('waterless');
      window.setTimeout(updAllNav,120);
    });
  })();
  (function(){
    var ww=document.querySelector('[data-ww]');
    if(!ww||ww.getAttribute('data-ww-bound')==='true') return;
    ww.setAttribute('data-ww-bound','true');
    ww.classList.add('ww--anim');
    var items=[].slice.call(ww.querySelectorAll('.ww__step, .ww__chips'));
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-shown');io.unobserve(e.target);}});},{threshold:0.35});
      items.forEach(function(el){io.observe(el);});
    } else { items.forEach(function(el){el.classList.add('is-shown');}); }
  })();
  (function(){
    var sc=document.querySelector('[data-scent]');
    if(!sc||sc.getAttribute('data-scent-bound')==='true') return;
    sc.setAttribute('data-scent-bound','true');
    sc.classList.add('scent--anim');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){sc.classList.add('is-in');io.disconnect();}});},{threshold:0.15});
      io.observe(sc);
    } else { sc.classList.add('is-in'); }
  })();
  (function(){
    var root=document.querySelector('[data-dev]');
    if(!root||root.getAttribute('data-dev-bound')==='true') return;
    root.setAttribute('data-dev-bound','true');
    var tabs=[].slice.call(root.querySelectorAll('[data-dev-tab]'));
    var panels=[].slice.call(root.querySelectorAll('[data-dev-panel]'));
    var tracks=[].slice.call(root.querySelectorAll('[data-rail]'));
    function updNav(track){
      var rail=track.closest('.dev__rail'); if(!rail) return;
      var prev=rail.querySelector('.dev__nav--prev'), next=rail.querySelector('.dev__nav--next');
      var max=track.scrollWidth-track.clientWidth-4;
      if(prev) prev.disabled=track.scrollLeft<=4;
      if(next) next.disabled=(track.scrollLeft>=max)||(max<=4);
    }
    function updAll(){ tracks.forEach(updNav); }
    tracks.forEach(function(t){ t.addEventListener('scroll',function(){ updNav(t); }); });
    function activate(sp){
      tabs.forEach(function(t){var on=t.getAttribute('data-dev-tab')===sp;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on?'true':'false');});
      panels.forEach(function(p){var on=p.getAttribute('data-dev-panel')===sp;p.classList.toggle('is-active',on);p.classList.remove('is-enter');if(on){window.requestAnimationFrame(function(){p.classList.add('is-enter');});}});
      window.setTimeout(updAll,60);
    }
    tabs.forEach(function(t){t.addEventListener('click',function(){activate(t.getAttribute('data-dev-tab'));});});
    root.addEventListener('click',function(e){
      var nav=e.target.closest('.dev__nav'); if(!nav) return;
      var rl=nav.closest('.dev__rail').querySelector('[data-rail]');
      if(rl) rl.scrollBy({left:(nav.classList.contains('dev__nav--next')?1:-1)*Math.round(rl.clientWidth*0.8),behavior:'smooth'});
    });
    window.addEventListener('resize',updAll);
    window.setTimeout(updAll,120);
    root.addEventListener('submit',function(event){
      var form=event.target.closest('[data-ap-setup-form]'); if(!form||!window.fetch) return;
      event.preventDefault();
      var button=form.querySelector('[data-ap-setup-atc]');
      if(button){button.disabled=true;button.classList.add('is-loading');}
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
        .then(function(){
          if(button){button.classList.remove('is-loading');button.classList.add('is-added');}
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('ap:cart:add'));
          window.setTimeout(function(){if(!button)return;button.disabled=false;button.classList.remove('is-added');},1600);
        }).catch(function(){if(button){button.classList.remove('is-loading');}form.submit();});
    });
  })();
  (function(){
    var root=document.querySelector('[data-cat]');
    if(!root||root.getAttribute('data-cat-bound')==='true') return;
    root.setAttribute('data-cat-bound','true');
    var track=root.querySelector('[data-rail]'); if(!track) return;
    var prev=root.querySelector('.cat__nav--prev'), next=root.querySelector('.cat__nav--next');
    function upd(){var max=track.scrollWidth-track.clientWidth-4;if(prev)prev.disabled=track.scrollLeft<=4;if(next)next.disabled=(track.scrollLeft>=max)||(max<=4);}
    track.addEventListener('scroll',upd);
    root.addEventListener('click',function(e){var n=e.target.closest('.cat__nav');if(!n)return;track.scrollBy({left:(n.classList.contains('cat__nav--next')?1:-1)*Math.round(track.clientWidth*0.85),behavior:'smooth'});});
    window.addEventListener('resize',upd);
    window.setTimeout(upd,120);
  })();
  (function(){
    var root=document.querySelector('[data-proof]');
    if(!root||root.getAttribute('data-proof-bound')==='true') return;
    root.setAttribute('data-proof-bound','true');
    var track=root.querySelector('[data-rail]'); if(!track) return;
    var prev=root.querySelector('.proof__nav--prev'), next=root.querySelector('.proof__nav--next');
    var dotsWrap=root.querySelector('[data-dots]');
    var cards=[].slice.call(track.querySelectorAll('.rev'));
    track.scrollLeft=0;
    if(dotsWrap){cards.forEach(function(c,i){var b=document.createElement('button');b.type='button';b.className='proof__dot';b.setAttribute('aria-label','Go to review '+(i+1));b.addEventListener('click',function(){track.scrollTo({left:track.scrollLeft+c.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:'smooth'});});dotsWrap.appendChild(b);});}
    function activeIdx(){var gl=track.getBoundingClientRect().left;var best=0,bd=1e9;cards.forEach(function(c,i){var d=Math.abs(c.getBoundingClientRect().left-gl);if(d<bd){bd=d;best=i;}});return best;}
    function upd(){var max=track.scrollWidth-track.clientWidth-4;if(prev)prev.disabled=track.scrollLeft<=4;if(next)next.disabled=(track.scrollLeft>=max)||(max<=4);if(dotsWrap){var a=activeIdx();[].forEach.call(dotsWrap.children,function(d,i){d.classList.toggle('is-on',i===a);});}}
    track.addEventListener('scroll',upd);
    root.addEventListener('click',function(e){var n=e.target.closest('.proof__nav');if(!n)return;track.scrollBy({left:(n.classList.contains('proof__nav--next')?1:-1)*Math.round(track.clientWidth*0.85),behavior:'smooth'});});
    window.addEventListener('resize',upd);
    window.setTimeout(upd,120);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-homepage-rebuild"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var ww=document.querySelector('[data-ww]');
    if(!ww||ww.getAttribute('data-ww-bound')==='true') return;
    ww.setAttribute('data-ww-bound','true');
    ww.classList.add('ww--anim');
    var items=[].slice.call(ww.querySelectorAll('.ww__step, .ww__chips'));
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-shown');io.unobserve(e.target);}});},{threshold:0.35});
      items.forEach(function(el){io.observe(el);});
    } else { items.forEach(function(el){el.classList.add('is-shown');}); }
  })();
  (function(){
    var sc=document.querySelector('[data-scent]');
    if(!sc||sc.getAttribute('data-scent-bound')==='true') return;
    sc.setAttribute('data-scent-bound','true');
    sc.classList.add('scent--anim');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){sc.classList.add('is-in');io.disconnect();}});},{threshold:0.15});
      io.observe(sc);
    } else { sc.classList.add('is-in'); }
  })();
  (function(){
    var root=document.querySelector('[data-dev]');
    if(!root||root.getAttribute('data-dev-bound')==='true') return;
    root.setAttribute('data-dev-bound','true');
    var tabs=[].slice.call(root.querySelectorAll('[data-dev-tab]'));
    var panels=[].slice.call(root.querySelectorAll('[data-dev-panel]'));
    var tracks=[].slice.call(root.querySelectorAll('[data-rail]'));
    function updNav(track){
      var rail=track.closest('.dev__rail'); if(!rail) return;
      var prev=rail.querySelector('.dev__nav--prev'), next=rail.querySelector('.dev__nav--next');
      var max=track.scrollWidth-track.clientWidth-4;
      if(prev) prev.disabled=track.scrollLeft<=4;
      if(next) next.disabled=(track.scrollLeft>=max)||(max<=4);
    }
    function updAll(){ tracks.forEach(updNav); }
    tracks.forEach(function(t){ t.addEventListener('scroll',function(){ updNav(t); }); });
    function activate(sp){
      tabs.forEach(function(t){var on=t.getAttribute('data-dev-tab')===sp;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on?'true':'false');});
      panels.forEach(function(p){var on=p.getAttribute('data-dev-panel')===sp;p.classList.toggle('is-active',on);p.classList.remove('is-enter');if(on){window.requestAnimationFrame(function(){p.classList.add('is-enter');});}});
      window.setTimeout(updAll,60);
    }
    tabs.forEach(function(t){t.addEventListener('click',function(){activate(t.getAttribute('data-dev-tab'));});});
    root.addEventListener('click',function(e){
      var nav=e.target.closest('.dev__nav'); if(!nav) return;
      var rl=nav.closest('.dev__rail').querySelector('[data-rail]');
      if(rl) rl.scrollBy({left:(nav.classList.contains('dev__nav--next')?1:-1)*Math.round(rl.clientWidth*0.8),behavior:'smooth'});
    });
    window.addEventListener('resize',updAll);
    window.setTimeout(updAll,120);
    root.addEventListener('submit',function(event){
      var form=event.target.closest('[data-ap-setup-form]'); if(!form||!window.fetch) return;
      event.preventDefault();
      var button=form.querySelector('[data-ap-setup-atc]');
      if(button){button.disabled=true;button.classList.add('is-loading');}
      var cartAddUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/')+'cart/add.js';
      fetch(cartAddUrl,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
        .then(function(){
          if(button){button.classList.remove('is-loading');button.classList.add('is-added');}
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('ap:cart:add'));
          window.setTimeout(function(){if(!button)return;button.disabled=false;button.classList.remove('is-added');},1600);
        }).catch(function(){if(button){button.classList.remove('is-loading');}form.submit();});
    });
  })();
  (function(){
    var root=document.querySelector('[data-cat]');
    if(!root||root.getAttribute('data-cat-bound')==='true') return;
    root.setAttribute('data-cat-bound','true');
    var track=root.querySelector('[data-rail]'); if(!track) return;
    var prev=root.querySelector('.cat__nav--prev'), next=root.querySelector('.cat__nav--next');
    function upd(){var max=track.scrollWidth-track.clientWidth-4;if(prev)prev.disabled=track.scrollLeft<=4;if(next)next.disabled=(track.scrollLeft>=max)||(max<=4);}
    track.addEventListener('scroll',upd);
    root.addEventListener('click',function(e){var n=e.target.closest('.cat__nav');if(!n)return;track.scrollBy({left:(n.classList.contains('cat__nav--next')?1:-1)*Math.round(track.clientWidth*0.85),behavior:'smooth'});});
    window.addEventListener('resize',upd);
    window.setTimeout(upd,120);
  })();
  (function(){
    var root=document.querySelector('[data-proof]');
    if(!root||root.getAttribute('data-proof-bound')==='true') return;
    root.setAttribute('data-proof-bound','true');
    var track=root.querySelector('[data-rail]'); if(!track) return;
    var prev=root.querySelector('.proof__nav--prev'), next=root.querySelector('.proof__nav--next');
    var dotsWrap=root.querySelector('[data-dots]');
    var cards=[].slice.call(track.querySelectorAll('.rev'));
    track.scrollLeft=0;
    if(dotsWrap){cards.forEach(function(c,i){var b=document.createElement('button');b.type='button';b.className='proof__dot';var home=document.querySelector('[data-ap-home-rebuild]');var label=(home&&home.getAttribute('data-review-label'))||'Go to review __number__';b.setAttribute('aria-label',label.replace('__number__',i+1));b.addEventListener('click',function(){track.scrollTo({left:track.scrollLeft+c.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:'smooth'});});dotsWrap.appendChild(b);});}
    function activeIdx(){var gl=track.getBoundingClientRect().left;var best=0,bd=1e9;cards.forEach(function(c,i){var d=Math.abs(c.getBoundingClientRect().left-gl);if(d<bd){bd=d;best=i;}});return best;}
    function upd(){var max=track.scrollWidth-track.clientWidth-4;if(prev)prev.disabled=track.scrollLeft<=4;if(next)next.disabled=(track.scrollLeft>=max)||(max<=4);if(dotsWrap){var a=activeIdx();[].forEach.call(dotsWrap.children,function(d,i){d.classList.toggle('is-on',i===a);});}}
    track.addEventListener('scroll',upd);
    root.addEventListener('click',function(e){var n=e.target.closest('.proof__nav');if(!n)return;track.scrollBy({left:(n.classList.contains('proof__nav--next')?1:-1)*Math.round(track.clientWidth*0.85),behavior:'smooth'});});
    window.addEventListener('resize',upd);
    window.setTimeout(upd,120);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
          return;
        }

        const details = disclosure.querySelector('details');
        if (!details) return;
        details.removeAttribute('open');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (typeof this.searchModal?.close === 'function') this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
